import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-5" }
const _hoisted_2 = { class: "text-center font-bold text-2xl mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center pt-3"
}
const _hoisted_4 = {
  key: 1,
  class: "flex justify-center pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    backdrop: _ctx.backdrop,
    visible: _ctx.visible
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Title), 1)
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Main), 1)
    ]),
    footer: _withCtx(() => [
      (_ctx.riepilogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              class: "ml-4 py-2 px-4"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Chiudi ")
              ])),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
              class: "col-start-3 py-2 px-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reject'))),
              class: "ml-4 py-2 px-4"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Chiudi ")
              ])),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["backdrop", "visible"]))
}